import { render } from "./ReviewCard.vue?vue&type=template&id=1734acf8"
import script from "./ReviewCard.vue?vue&type=script&lang=js"
export * from "./ReviewCard.vue?vue&type=script&lang=js"

import "./ReviewCard.vue?vue&type=style&index=0&id=1734acf8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__